import Travel from "./Travel";
import Model from "./Model";
import Resource from "./Resource";

export default class TravelDate extends Model {
    constructor(data) {
        super(data);

        this.relation('travel', Travel)
            .relationCollection('resources_room', Resource);
    }

    get from() {
        const from = this.get('from');
        return new Date(from);
    }

    get to() {
        const to = this.get('to');
        return new Date(to);
    }
}
